export function isExternalUrl(url: string) {
  return new RegExp(`^((https?:)?//)`, `i`).test(url);
}
